import React from 'react';

import Badge from 'CommonComponents/Badge';

export const STATUS_LABELS = {
    R: () => $t('Red'),
    A: () => $t('Amber'),
    G: () => $t('Green'),
    not_configured: () => $t('Not configured'),
};

const VARIANTS = {
    R: 'danger',
    A: 'warning',
    G: 'success',
    not_configured: 'neutral',
};

/**
 * A pack status as a coloured pill.
 */
const StatusPill = ({ status }) => <Badge variant={VARIANTS[status] || 'neutral'}>{STATUS_LABELS[status]?.() ?? status}</Badge>;

export default StatusPill;
